import { CloseRounded } from '@mui/icons-material';
import BasicButton from '../Button';
import * as S from './style';
import { ReactNode } from 'react';
import colors from '../../theme/colors';
import * as T from '../Typography';

interface ModalProps {
  visible: boolean;
  setIsModalVisible: (visible: boolean) => void;
  children: ReactNode;
  onCancel?: () => void;
  bgColor?: string;
  [key: string]: any;
  headerTitle?: string;
}

const Modal = ({
  visible,
  setIsModalVisible,
  children,
  onCancel,
  bgColor,
  headerTitle,
  withFooter,
  footerConfirmButtonLabel,
  footerConfirmButtonColor,
  onConfirmClicked,
  ...props
}: ModalProps) => {
  const handleCancel = () => {
    if (typeof onCancel === 'function') {
      onCancel();
    }
    if (typeof setIsModalVisible === 'function') {
      setIsModalVisible(false);
    }
  };

  return (
    <S.Modal
      open={visible}
      onClose={handleCancel}
      aria-label="dialog"
      aria-modal="true"
      role="dialog"
      {...props}
    >
      <S.Container>
      {!!headerTitle && <S.Header>
        <T.H5>
        {headerTitle}
        </T.H5>
        <CloseRounded 
          sx={{ width: 24, height: 24, cursor: 'pointer' }}
          htmlColor={colors.neutral.shades.shade700}
          onClick={onCancel}
        />
      </S.Header>}
      <S.ContentContainer>
        {children}
      </S.ContentContainer>
      {withFooter && <S.Footer>
        <T.Link
          decoration={'none'}
          onClick={onCancel}
          mr={3}
        >
          Cancel
        </T.Link>
        <BasicButton 
          handleClick={onConfirmClicked}
          variant={footerConfirmButtonColor}
          width='fit-content'
        >
          { footerConfirmButtonLabel }
        </BasicButton>
      </S.Footer>}
      </S.Container>
    </S.Modal>
  );
};

export default Modal;
